
function SdSelectCtrl(TranslationService) {
    var ctrl = this;

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {
        ctrl.loaded = false;
        
    };   

    ctrl.selectOption = function (option, event) {
        ctrl.ngModel = option.Key;
        ctrl.value = option.Value;
    };

    ctrl.getValue = function () {
        var itemSelected = getSelectedItem();

        if (itemSelected)
            return itemSelected.Value;
        
        return '';
    };

    ctrl.hasDuplication = function () {
        if (ctrl.alertDuplication) {
            var itemSelected = getSelectedItem();

            if (itemSelected) {
                ctrl.listDuplication.map(function (item) {
                    if (item.Key == itemSelected.Key)
                        itemSelected.Duplicate = item.Duplicate;
                })
                return itemSelected.Duplicate;
            }
        }
        
        return false;
    }

    ctrl.checkDuplication = function () {
        var uniqueList = [];

        ctrl.listDuplication.map(function (option) {
            if (!uniqueList.some(function (item) { return item.Key == option.Key })) {
                option.Duplicate = false;
                uniqueList.push(option);
            }
            else {
                option.Duplicate = true;
            }
        });
    }

    function getSelectedItem() {
        if (ctrl.ngModel && ctrl.options) {
            var itemSelected = ctrl.options.find(function (option) {
                return option.Key == ctrl.ngModel;
            });

            if (itemSelected) return itemSelected;
        }
        return '';
    }
}

SdSelectCtrl.$inject = ['TranslationService', 'StoreService'];

seedWebApp.component('sdSelect', {
    controller: SdSelectCtrl,
    bindings: {
        ngModel: '=',
        label: '<',        
        options: '=',
        disabled: '<',
        width: '@',
        alertDuplication: '@',
        listDuplication: '=',
    },
    templateUrl: '/SPA/Components/sd-select.html'
});